import { uploadArticleImage, uploadContentThumbnail } from '@/services/api/requests/content';
import { useMutation } from '@tanstack/react-query';

// Low-level upload mutations used by the create/edit flows. Cache invalidation and
// toasts are handled by the orchestrating flow once all uploads settle.
const useContentImageUpload = () => {
  const thumbnail = useMutation({
    mutationFn: async ({ id, file }: { id: string; file: File }) => uploadContentThumbnail(id, file),
  });

  const articleImage = useMutation({
    mutationFn: async ({
      id,
      file,
      sectionId,
      subsectionId,
    }: {
      id: string;
      file: File;
      sectionId: string;
      subsectionId?: string;
    }) => uploadArticleImage(id, file, sectionId, subsectionId),
  });

  return {
    uploadThumbnailAsync: thumbnail.mutateAsync,
    uploadArticleImageAsync: articleImage.mutateAsync,
    isUploading: thumbnail.isPending || articleImage.isPending,
  };
};

export default useContentImageUpload;
